module.exports = __webpack_public_path__ + "img/wikimedia.ee62c582.png";